import { useLang } from "@/context/LangContext";
import { money, PLACEHOLDER } from "@/lib/constants";
import { Badge } from "@/components/ui/badge";
import { Star, MapPin, Headphones, BadgeCheck } from "lucide-react";

export default function StudioCard({ studio, onOpen }) {
  const { t } = useLang();
  const isRec = studio.type === "recording";
  return (
    <div
      data-testid={`studio-card-${studio.id}`}
      onClick={() => onOpen(studio)}
      className="card-hover cursor-pointer rounded-2xl overflow-hidden border border-border bg-card"
    >
      <div className="relative h-44">
        <img src={(studio.photos && studio.photos[0]) || PLACEHOLDER} alt={studio.name} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className={`${isRec ? "bg-blue-500/90" : "bg-pink-500/90"} text-white border-0`}>
            {isRec ? t("recording") : t("rehearsal")}
          </Badge>
          {studio.engineer_available && (
            <Badge className="bg-emerald-500/90 text-white border-0 gap-1">
              <Headphones className="w-3 h-3" /> {t("with_engineer")}
            </Badge>
          )}
        </div>
        {studio.verified && (
          <Badge className="absolute top-3 right-3 bg-blue-600/90 text-white border-0 gap-1">
            <BadgeCheck className="w-3 h-3" /> {t("verified")}
          </Badge>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-semibold text-lg leading-tight">{studio.name}</h3>
          {studio.rating > 0 && (
            <span className="flex items-center gap-1 text-sm text-accent shrink-0">
              <Star className="w-3.5 h-3.5 fill-accent" /> {studio.rating}
            </span>
          )}
        </div>
        <p className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
          <MapPin className="w-3 h-3" /> {studio.city}
          {studio.distance_km != null && <span>· {studio.distance_km} km</span>}
        </p>
        <div className="flex items-end justify-between mt-3">
          <p className="text-sm">
            <span className="font-display text-xl font-bold text-primary">{money(studio.price_per_hour, studio.currency)}</span>
            <span className="text-muted-foreground text-xs">{t("per_hour")}</span>
          </p>
          <span className="text-xs font-semibold text-primary">{t("view")} →</span>
        </div>
      </div>
    </div>
  );
}
